//@flow

const TrackType: PKTrackTypes = {
  VIDEO: 'video',
  AUDIO: 'audio',
  TEXT: 'text'
};

export {TrackType};



// WEBPACK FOOTER //
// ./track/track-type.js


// WEBPACK FOOTER //
// core/track/track-type.js